import { Navigate } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { RedirectToCompensationsPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToCompensationsPage = () => {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(RedirectToCompensationsPageDocument, {
    variables: {
      companyId: company.id,
    },
    fetchPolicy: 'network-only',
    skip: !company.id,
  })
  const isCyclesFeatureEnabled = data?.features?.featuresConnection?.nodes[0]?.enabled ?? false
  const compensationsDefinitionPage = navigation.compensations.definition.fullPath()
  const cyclesPage = navigation.compensations.cycles.list.fullPath()

  if (loading) {
    return (
      <Box gap="s8" padding="s48" alignItems="center" data-testid="compensations-root-page-loading">
        <Spinner size="s32" />
      </Box>
    )
  }

  return <Navigate replace to={isCyclesFeatureEnabled ? cyclesPage : compensationsDefinitionPage} />
}

export default RedirectToCompensationsPage
